module.exports = __webpack_public_path__ + "static/media/k5-texture-transparent.c14b6fee.png";